import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const BottomNavbar = (props) => {
  const links = [
    props.t("bottomNavBar.daily"),
    props.t("bottomNavBar.weekly"),
    props.t("bottomNavBar.monthly"),
  ];
  const linksCode = ["daily", "weekly", "monthly"];
  const navigate = useNavigate();

  function changeDateType(link) {
    let dateType = "";
    switch (link) {
      case props.t("bottomNavBar.monthly"):
        dateType = "monthly";
        break;
      case props.t("bottomNavBar.weekly"):
        dateType = "weekly";
        break;
      case props.t("bottomNavBar.daily"):
        dateType = "daily";
        break;
      default:
        dateType = props.page;
    }
    if (props.page !== dateType && props.pageType === "reportIndex") {
      navigate(`/${dateType}`, { state: { currentDate: props.currentDate } });
    } else if (props.page !== dateType) {
      props.changeDetail(dateType);
    }
  }

  return (
    <div className="bottom-nav">
      {links.map((link, index) => (
        <button
          className="botton-nav__button"
          key={linksCode[index]}
          onClick={(event) => changeDateType(link)}
          style={
            linksCode[index] === props.page
              ? { fontWeight: "bold", color: "black" }
              : {}
          }
        >
          {link}
        </button>
      ))}
    </div>
  );
};

export default BottomNavbar;
